import script from "./appNav.vue?vue&type=script&setup=true&lang=js"
export * from "./appNav.vue?vue&type=script&setup=true&lang=js"

import "./appNav.vue?vue&type=style&index=0&id=925b383a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-925b383a"]])

export default __exports__